import type { FC } from "react"

import { useRecoilValue } from "recoil"

import {
  panelAutoPlacementNodesState,
  panelAutoPlacementFacesState,
} from "~/containers/LegacyDesigner/state/elements/transactions/autoPlacePanels"

import { RainbowFaces } from "../Visuals/Faces"
import { RainbowNodeGroups } from "../Visuals/NodeGroups"

export const AutoPlacementVisualization: FC = () => {
  const nodeGroups = useRecoilValue(panelAutoPlacementNodesState)
  const faceGroups = useRecoilValue(panelAutoPlacementFacesState)

  return (
    <>
      <RainbowNodeGroups nodeGroups={nodeGroups} />
      <RainbowFaces faces={faceGroups} />
    </>
  )
}
